import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { Header } from '../Common';
import Products from '../../Models/Products';

class BuyerAskEstimationEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            info: '',
            title: '',
            description: '',
            category: '',
            subCategory: '',
            date: '',
            budgets: '',
            categories: [],
            subCategories: [],
            budget: [],
            budgetValue: ''

        };
        console.log(this.props.location.state.id)
        this.getBudgetList();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getBudgetList() {
        Products.getBudget().then(res => {
            this.setState({ budget: res.data.message })
        })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    componentDidMount() {
        var x = JSON.parse(window.localStorage.getItem('info'));
        this.setState({ info: x })
    }

    updateChange(e) {
        this.setState({
            budgets: e.target.value,
        })
    }
    handleClick() {
        // console.log(this.state.datas)

        if (this.state.info === null) {
            return (
                <div className="container">
                    <form >
                        <div>&nbsp;</div>
                        <div className="form-group">
                            <label htmlFor="pwd"><span className="request_fonts mr-4"><b>Title</b></span>*required</label>
                            <input type="text" className="catagory_select" id="title" placeholder="Enter Title" value={this.state.title} onChange={this.updateValue.bind(this, 'title')} />
                        </div>
                        <div>&nbsp;</div>
                        <div className="form-group">
                            <label htmlFor="pwd"><span className="request_fonts mr-4"><b>Request Content</b></span>*required</label>
                            <textarea className="form-control " row="5" id="descrition" placeholder="Write something.." value={this.state.description} onChange={this.updateValue.bind(this, 'description')} ></textarea>
                        </div>
                        <div>
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <span><b>Application Date</b></span>
                                    <div>*required</div>
                                </div>
                                <div className="col-md-6">
                                    <input type="date" className="catagory_select" id="date" placeholder="Date" value={this.state.date} onChange={this.updateValue.bind(this, 'date')} />
                                </div>
                                <div className="col-md-2"></div>
                            </div>
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span><b>Budget</b></span>
                                            </td>
                                            <td className="outer_td"></td>
                                            <td className="inner_td">
                                                <select className="catagory_select" ref="budget" >
                                                    <option>{this.props.t('1')}</option>
                                                    {this.state.budget.map(rp =>
                                                        <option value={rp.id} key={rp.id}>
                                                            {rp.budget_range}
                                                        </option>
                                                    )}
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="button_div">
                                {/* <Link to={'/request-confirm'}> */}
                                <button type="submit" className="agree_button">Confirm The Contents of the Request</button>
                                {/* </Link> */}
                            </div>
                            <div style={{ color: 'red' }}>Please Login</div>
                            <div >
                                <div className="request_rules">
                                    Request board rules
                                                                </div>
                                <div>&nbsp;</div>
                                <div>
                                    <ul>
                                        <li>Please request a service that can be completed online.
                                                                    You can not request services that require a real meeting or sending something.</li>
                                        <li>It is prohibited to give a phone number or Skype ID.</li>
                                        <li>Posts that violate the guidelines may be hidden (guidelines are here ).</li>
                                        <li>Opinions and requests to kokonara are <Link to={"#"} className="blue_text">are here</Link> .</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            )
        } else {
            return (
                <div className="container">
                    <form >
                        <div>&nbsp;</div>
                        <div className="form-group">
                            <label htmlFor="pwd"><span className="request_fonts mr-4"><b>Title</b></span>*required</label>
                            <input type="text" className="catagory_select" id="title" placeholder="Enter Title" value={this.state.title} onChange={this.updateValue.bind(this, 'title')} />
                        </div>
                        <div>&nbsp;</div>
                        <div className="form-group">
                            <label htmlFor="pwd"><span className="request_fonts mr-4"><b>Request Content</b></span>*required</label>
                            <textarea className="form-control " row="5" id="descrition" placeholder="Write something.." value={this.state.description} onChange={this.updateValue.bind(this, 'description')} ></textarea>
                        </div>
                        <div>
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <span><b>Application Date</b></span>
                                    <div>*required</div>
                                </div>
                                <div className="col-md-6">
                                    <input type="date" className="catagory_select" id="date" placeholder="Date" value={this.state.date} onChange={this.updateValue.bind(this, 'date')} />
                                </div>
                                <div className="col-md-2"></div>
                            </div>
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span><b>Budget</b></span>
                                            </td>
                                            <td className="outer_td"></td>
                                            <td className="inner_td">
                                                <select className="catagory_select" onChange={this.updateChange.bind(this)} value={this.state.budgets}>
                                                    <option>{this.props.t('1')}</option>
                                                    {this.state.budget.map(rp =>
                                                        <option value={rp.id} key={rp.budget_range}>
                                                            {rp.budget_range}
                                                        </option>
                                                    )}
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="button_div">
                                <Link to={{
                                    pathname: `/request-confirm/${this.props.location.state.id}`,
                                    state: {
                                        budgets: this.state.budgets,
                                        date: this.state.date,
                                        title: this.state.title,
                                        content: this.state.description,
                                        product_id: this.props.location.state.id,
                                        buyer_id: this.state.info.id,
                                    }
                                }}>
                                    <button type="submit" className="agree_button" >Confirm The Contents of the Request</button>
                                </Link>
                            </div>
                            <div >
                                <div className="request_rules">
                                    Request board rules
                                                                </div>
                                <div>&nbsp;</div>
                                <div>
                                    <ul>
                                        <li>Please request a service that can be completed online.
                                                                    You can not request services that require a real meeting or sending something.</li>
                                        <li>It is prohibited to give a phone number or Skype ID.</li>
                                        <li>Posts that violate the guidelines may be hidden (guidelines are here ).</li>
                                        <li>Opinions and requests to kokonara are <Link to={"#"} className="blue_text">are here</Link> .</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="container-fluid">
                    {/* <div className="container"> */}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-2"></div>
                            <div className="col-md-8">
                                <div className="back_div">
                                    <div className="assure">
                                        {this.props.t('0')}
                                    </div>
                                    <div className="mini_padding">
                                        <div className="mini_padding inner-div">

                                            {this.handleClick()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                    </div>
                    {/* </div> */}
                </div>
                <Footer />
            </div>
        )
    }
}

export { BuyerAskEstimationEdit }

 BuyerAskEstimationEdit = withTranslation('src_Components_Transactions_BuyerAskEstimationEdit')(BuyerAskEstimationEdit);